import script from "./PasswordPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordPrompt.vue?vue&type=script&setup=true&lang=js"

import "./PasswordPrompt.vue?vue&type=style&index=0&id=24e634f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e634f9"]])

export default __exports__